var path = '/components/state-manager/filter-field/types/select.tpl.html';
var html = "<selectize\n        items=\"vm.items\"\n        ng-model=\"vm.store.state.filters[vm.col.key]\"\n        on-change=\"vm.select(model)\"\n        max-items=\"1000\"></selectize>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/state-manager/filter-field/types/select.tpl.html
// module id = 2025
// module chunks = 1